import { ActivityModel, ValidationStatus } from 'types/shared'
import api from 'utils/api'
import useInterpolateUrl from '../hooks/useInterpolateUrl'
import { USER_ERROR_TAG } from 'utils/getUserErrorFromAPIResponse'

export const useValidateUsingCallback = () => {
  const interpolateUrl = useInterpolateUrl()

  const validateUsingCallback = async ({
    validation_activity_callback: validationCallback,
    value
  }: Pick<ActivityModel, 'validation_activity_callback' | 'value'>): Promise<{
    validationStatus: ValidationStatus
    helperText?: {
      des: string
      complement?: string
    }
  }> => {
    if (!validationCallback || value === '' || value === undefined) {
      return { validationStatus: 'pending' }
    }

    const reqObj = {
      content: value
    }

    const onError = (e: Error) => ({ success: false, message: e.message })

    const interpolatedValidationCallback = interpolateUrl(validationCallback)

    const { success, message = '' } = await api
      .postInputValidation(reqObj, interpolatedValidationCallback, false)
      .catch(onError)
    const validMessage = 'activity-input.validation.is_valid'

    const hasCustomError = message.includes(USER_ERROR_TAG)
    const errorMessage = hasCustomError ? message : 'invalid-format'

    return {
      validationStatus: success ? 'valid' : 'invalid',
      helperText: { des: success ? validMessage : errorMessage }
    }
  }

  return validateUsingCallback
}
